import { request } from "../libs";
import store from '../../store';
const timeout = 3000;

export default function logout({ refreshToken }) {
	return request(
		store.getters["env/serverUrl"] + "/auth/logout",
		{
			method: "POST",
			body: JSON.stringify({ refreshToken })
		},
		timeout
	);
}
